import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Pcomment(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python List Method Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python list method tutorial for beginners.This function is used to add an element at the end of the list." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Searching in list python,python tuple,python tuple vs list,python list of tuples,python list to tuple,python list method,python list methods,python list methods of object,python dunder methods list,list method python 3,python built in functions list,python list methods in module,python list dll functions
,python list methods examples,python list lambda functions,python list of functions with arguments"/>
<link rel="canonical" href="https://www.codeexampler.com/python-list-method" />
</Helmet>

<div className='lg:pl-56'>


<h1 className="m-4 mh1"> Python List Method</h1>

<div className="first">
        <a href="/python-list">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<h2 className="mt-4 mh2">Python list methods or Python list of functions </h2>
<h3 className="mt-4 mh3">Adding Elements to a List:</h3>
<p className="mt-4 para">This function uses to add an element at the end of the List.<br/>
There are three methods for adding things to the python list:<br/>
1, Python list append( )<br/>
2, Python list extend( )<br/>
3, Python list insert( )<br/>
</p>
<h2 className="mt-4 mh2">1. Python list append</h2>
<p className="mt-4 para">Python List append() method makes it easy to build lists dynamically.
</p>


<h2 className='headings'>Q-Write a Program Python list append b with a Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">A</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">60</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-7">B</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-4">A</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">append</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">80</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">A</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">60</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">80</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 




<h2 className='headings'>Q-I want to buy fruits use for Python list append?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">fruits</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">fruits</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">append</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">'</span>                  
                  <span className="qwerty-8">mango</span>
                  <span className="qwerty-1">'</span>                  
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-4">fruits</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">append</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">'</span>                  
                  <span className="qwerty-8">apple</span>
                  <span className="qwerty-1">'</span>                  
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-4">fruits</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">append</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">'</span>                  
                  <span className="qwerty-8">banana</span>
                  <span className="qwerty-1">'</span>                  
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">fruits</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-7">'</span>
                  <span className="qwerty-6">mango</span>
                  <span className="qwerty-7">'</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-7">'</span>
                  <span className="qwerty-6">apple</span>
                  <span className="qwerty-7">'</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-7">'</span>
                  <span className="qwerty-6">banana</span>
                  <span className="qwerty-7">'</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 



<h2 className='headings'>Q-Write a Program to input Five elements and store them into a list using for loop in Python list append?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-7">for </span>
                  <span className="qwerty-4">i </span>
                  <span className="qwerty-5">in </span>
                  <span className="qwerty-6">range </span>
                  <span className="qwerty-1">(</span>                  
                  <span className="qwerty-8">1</span>
                  <span className="qwerty-1">,</span>                  
                  <span className="qwerty-8">6</span>
                  <span className="qwerty-1">):</span>
           {"\n"}
                  <span className="qwerty-4">    n</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>                  
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>                  
                  <span className="qwerty-10">Enter a no</span>
                  <span className="qwerty-1">"</span>                  
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-4">    x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">append</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-4">n</span>                  
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-4">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-2">Enter a no </span>
                  <span className="qwerty-3">24</span>
                    {"\n"}
                    <span className="qwerty-2">Enter a no </span>
                  <span className="qwerty-3">26</span>
                    {"\n"}
                    <span className="qwerty-2">Enter a no </span>
                  <span className="qwerty-3">46</span>
                    {"\n"}
                    <span className="qwerty-2">Enter a no </span>
                  <span className="qwerty-3">28</span>
                    {"\n"}
                    <span className="qwerty-2">Enter a no </span>
                  <span className="qwerty-3">54</span>
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">24</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">26</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">46</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">28</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">54</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 

<p className="mt-4 para">If you don't know about input in Python so check on <a href="https://www.codeexampler.com/python-input"> Python input tutorial</a>.</p>

<h2 className="mt-4 mh2">Python list extend</h2>
<p className="mt-4 para">Python list extend() use in python list extend for add multiple items to the ends of the list.
 </p>


<h2 className='headings'>Q-Python list extends the Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">A</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">B</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">A</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">extend</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-4">B</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">A</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  


<h3 className="mt-4 mh3">Difference between Append vs Extend in Python Lists</h3>


<h2 className='headings'>Q-Append vs Extend in Python Lists Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">A</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">B</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">A</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">extend</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-4">B</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">A</span>
                     <span className="qwerty-1">)</span>                 
           {"\n"}
           {"\n"}
                  <span className="qwerty-4">A</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">append</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-4">B</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">A</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">]</span>  
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-1">[</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">]</span>  
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 


<h2 className="mt-4 mh2">Python list Insert():</h2>

<p className="mt-4 para">Python list Insert an element into another list at a specific position.
</p>



<h2 className='headings'>Q-Python list insert() example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">1</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">2</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">3</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">insert</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-8">24</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">1</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">24</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">2</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">3</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 


<h2 className="mt-4 mh2">Python list update():</h2>
<p className="mt-4 para">the index used to change one of the list items</p>


<h2 className='headings'>Simple Python list example</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">80</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">80</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>


<p className="bold para ">But After use Python list update:</p>



<h2 className='headings'>Q-Use Python list update Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">80</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-8">2</span>
                  <span className="qwerty-1">:</span>
                  <span className="qwerty-8">3</span>
                  <span className="qwerty-1">]</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">]</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  


<h2 className="mt-4 mh2">Python list Slice() Example:</h2>



        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">[</span>                 
                     <span className="qwerty-8">0</span>                 
                     <span className="qwerty-1">]</span>                 
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">[</span>                 
                     <span className="qwerty-8">-1</span>                 
                     <span className="qwerty-1">]</span>                 
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">[</span>                 
                     <span className="qwerty-8">1</span>                 
                     <span className="qwerty-1">:</span>                 
                     <span className="qwerty-1">]</span>                 
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">[</span>                 
                     <span className="qwerty-1">:</span>                 
                     <span className="qwerty-8">5</span>                 
                     <span className="qwerty-1">]</span>                 
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">[</span>                 
                     <span className="qwerty-1">:</span>                 
                     <span className="qwerty-8">5</span>                 
                     <span className="qwerty-1">]</span>                 
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">[</span>                 
                     <span className="qwerty-8">0</span>                 
                     <span className="qwerty-1">:</span>                 
                     <span className="qwerty-8">5</span>                 
                     <span className="qwerty-1">:</span>                 
                     <span className="qwerty-8">2</span>                 
                     <span className="qwerty-1">]</span>                 
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                  <span className="qwerty-2">10</span>
                    {"\n"}
                  <span className="qwerty-2">50</span>
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">]</span>  
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">]</span>  
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">40</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">]</span>  
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">50</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>   


<h2 className="mt-4 mh2">Concatenating Two Lists in Python:</h2>



        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">a</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">b</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">11</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">22</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-10">33</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-8">c</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-4">a</span>
                  <span className="qwerty"> + </span>
                  <span className="qwerty-4">b</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-8">c</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-2">10</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">20</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">30</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">11</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">22</span>
                  <span className="qwerty-1">,</span>  
                  <span className="qwerty-2">33</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  

<h2 className="mt-4 mh2">Python Delete List:</h2>

<h3 className="mt-4 bold mh3">Python Remove() List</h3>

<p className="mt-4 para">It Removes a particular item from the List.</p>



<h2 className='headings'>Q-Python Remove list Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">remove</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  






<h2 className='headings'>Python Delete list Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-2">del </span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-8">1</span>
                  <span className="qwerty-10">:</span>
                  <span className="qwerty-8">2</span>
                  <span className="qwerty-1">]</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 


<h2 className="mt-4 mh2">Python Pop List</h2>
<h3 className="mt-4 mh3">Python Pop() method inside the list:</h3>
<p className="mt-4 para">Removes the last component
</p>




<h2 className='headings'>Q-Python Pop list Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">no</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">no</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">pop</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">no</span>
                     <span className="qwerty-1">)</span>                 
           {"\n"}
           {"\n"}
                  <span className="qwerty-7">   OR</span>
           {"\n"}
           {"\n"}
                  <span className="qwerty-4">no</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">pop</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">2</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">no</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">30</span>
                  <span className="qwerty-1">]</span>  
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 

<h2 className="mt-4 mh2">Python list clear() method:</h2>
<p className="mt-2 para">  it removes all element</p>



<h2 className='headings'>Q-Python Clear list Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">no</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">no</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">clear</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">no</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  

<h2 className="mt-4 mh2">Python List Index () Method:</h2>

<p className="mt-4 para">It returns the index no of the first Match.
</p>



<h2 className='headings'>Q-Python list Index() Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">60</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">index</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">)</span>
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">index</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">3</span>
                  <span className="qwerty-1">)</span>
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">index</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">3</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">5</span>
                  <span className="qwerty-1">)</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                  <span className="qwerty-6">3</span>
                    {"\n"}
                  <span className="qwerty-6">3</span>
                    {"\n"}
                  <span className="qwerty-6">4</span>
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  

<h2 className="mt-4 mh2">Python List Count:</h2>
<h3 className="mt-4 mh3">Python count() method:</h3>
<p className="mt-4 para">Python List Count to count the no of items
</p>


<h2 className='headings'>Q-Python list Count() Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1">=</span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">60</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">count</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">)</span>
                     <span className="qwerty-1">)</span>                 
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">count</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">)</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                  <span className="qwerty-6">1</span>
                    {"\n"}
                  <span className="qwerty-6">2</span>
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>    


<h2 className="mt-4 mh2">Python List sort:</h2>


<h2 className='headings'>Q-Python list sort() Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">2</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">5</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">6</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">8</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">4</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">sort</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">2</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">4</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">5</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">6</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">8</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>


<h2 className="mt-4 mh2">Python List Reverse():</h2>
<h3 className="mt-4 mh3">Python List Reverse:</h3>
<p className="mt-4 para">The List can be reverse when sorted, also using reverse, but the reverse is true.
</p>


<h2 className='headings'>Q-Python list reverse() Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">2</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">5</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">6</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">8</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">4</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">reverse</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">4</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">8</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">6</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">5</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">2</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>             
         



<h2 className='headings'>Q-Write a program to input five elements and add to a list  print all elements in descending order?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">2</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">5</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">6</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">8</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">4</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">sort</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">reverse</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
           {"\n"}
                  <span className="qwerty-7">   OR</span>
           {"\n"}
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty">.</span>
                  <span className="qwerty-2">sort</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-2">reverse</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-5">True</span>
                  <span className="qwerty-1">)</span>
           {"\n"}
                  <span className="qwerty-3">print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">x</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                  <span className="qwerty-6">8</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">6</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">5</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">4</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">2</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">1</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  


<h2 className="mt-4 mh2">Python List range:</h2>



<h2 className='headings'>Q-Python list Range Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-10">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-10">50</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-7">for </span>
                     <span className="qwerty-4">i </span>
                  <span className="qwerty-5">in </span>
                  <span className="qwerty-6">range</span >
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-8">6</span>
                     <span className="qwerty-1">):</span>                 
           {"\n"}
                  <span className="qwerty-3">    print</span>
                     <span className="qwerty-1">(</span>
                  <span className="qwerty-4">x</span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-8">0</span>
                  <span className="qwerty-1">:</span>
                  <span className="qwerty-4">i</span>
                  <span className="qwerty-1">]</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">]</span>
                    {"\n"}
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">]</span>
                    {"\n"}
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">30</span>
                  <span className="qwerty-1">]</span>
                    {"\n"}
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">40</span>
                  <span className="qwerty-1">]</span>
                    {"\n"}
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-6">10</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">20</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">30</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">40</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">50</span>
                  <span className="qwerty-1">]</span>
                    {"\n"}
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/python-list">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pcomment;